import angular from 'angular';
import ngRedux from 'ng-redux';
import { ConfigureStore } from './store.config.js';
import StoreService from './store.service.js';
import reduxUiRouter from 'redux-ui-router';
import { EnvironmentService } from '../../environment';
import { EpicsModule } from '../epics';
import { ng1 } from '@updater/redux-http-request';
import { MessageModule } from '../message';

export default angular
  .module('app.store', [
    EnvironmentService.name,
    EpicsModule.name,
    MessageModule.name,
    ngRedux,
    reduxUiRouter,
  ])
  .config(ConfigureStore)
  .factory('ng1RequestMiddleware', $http => ng1.middleware.create($http))
  .service('updStore', StoreService);
